import React from "react";
import { styled } from "@mui/system";
import { colors } from "../../../../../utils";
import TextView from "../../../../TextView";

const StatusBox = styled("div")(({ isPublic }) => ({
  height: "100%",
  display: "flex",
  alignItems: "center",
  padding: "2px 10px",
  backgroundColor: isPublic ? colors.LightGreenBackground : colors.TimedWheel,
  borderRadius: "20px",
  justifyContent: "center",
  width: "fit-content",
}));

const StatusText = styled(TextView)(({ isPublic }) => ({
  fontSize: "12px",
  lineHeight: "18px",
  paddingLeft: "5px",
  color: isPublic ? colors.PrimaryGreen : colors.StrokePrimary,
}));

const Status = ({ isPublic, icon, text }) => {
  return (
    <StatusBox isPublic={isPublic}>
      <img src={icon} width={20} height={20} alt="Status Icon" />
      <StatusText variant="tag" isPublic={isPublic}>
        {text}
      </StatusText>
    </StatusBox>
  );
};

export default Status; 